import factory from '../factory'
export default factory('SeminarDocuments')
